<!-- ---------------------------------------------------------------------- -->
<!--                        CABECERA DE LA SECCIÓN                          -->
<!-- ---------------------------------------------------------------------- -->
<div class="z-page-head z-rise">
  <div>
    <h1 class="z-page-title">Pulso</h1>
    <p class="z-page-subtitle">
      Cómo vamos: el NPS del programa en {{ periodo }}, su tendencia de los últimos
      trece meses y las sucursales que se salen del promedio.
      @if (alcance) {
        <span class="pulse-scope">Acotado a {{ alcance }}.</span>
      }
    </p>
  </div>

  <div class="z-page-actions">
    <button class="z-btn z-btn--glass" type="button" (click)="descargar()">
      <i class="bi bi-download" aria-hidden="true"></i> Descargar CSV
    </button>
  </div>
</div>

<!-- La barra pegajosa se queda fuera de .z-rise a propósito: un `transform`
     animado en un ancestro vuelve a ese ancestro el bloque contenedor de sus
     hijos `sticky` y `fixed`, y la barra dejaría de pegarse mientras dura la
     entrada. -->
<app-filter-bar [fields]="filtros"
                [selected]="seleccion"
                (selectedChange)="onFiltros($event)" />

<!-- ---------------------------------------------------------------------- -->
<!--                            BANDA DE KPIs                               -->
<!-- ---------------------------------------------------------------------- -->
<div class="z-kpi-grid">
  <app-stat-card class="z-rise z-rise-1"
                 label="NPS general"
                 [value]="general.nps"
                 suffix="%"
                 color="accent"
                 icon="bi-speedometer2"
                 [delta]="deltaGeneral"
                 [hint]="hintPeriodo" />

  <app-stat-card class="z-rise z-rise-2"
                 label="Comerciante"
                 [value]="comerciante.nps"
                 suffix="%"
                 color="magenta"
                 icon="bi-shop"
                 [delta]="deltaComerciante"
                 [hint]="hintPeriodo" />

  <app-stat-card class="z-rise z-rise-3"
                 label="Consumidor final"
                 [value]="consumidor.nps"
                 suffix="%"
                 color="teal"
                 icon="bi-people"
                 [delta]="deltaConsumidor"
                 [hint]="hintPeriodo" />

  <app-stat-card class="z-rise z-rise-4"
                 label="Alertas activas"
                 [value]="alertasActivas"
                 color="red"
                 icon="bi-exclamation-triangle"
                 [hint]="alertasHint"
                 route="/acciones" />
</div>

<!-- ---------------------------------------------------------------------- -->
<!--                             NPS GENERAL                                -->
<!-- ---------------------------------------------------------------------- -->
<section class="z-panel z-rise z-rise-5">
  <header class="z-panel-head">
    <div>
      <h2 class="z-panel-title">NPS General</h2>
      <p class="z-panel-hint">
        Neto de recomendación de {{ periodo }} y cómo se reparten los clientes.
      </p>
    </div>
  </header>

  <div class="z-panel-body">
    <div class="z-grid z-grid-2">

      <div class="pulse-hero">
        <div class="pulse-hero-figure">
          <app-chart [options]="donaGeneral" [height]="200" />
        </div>

        <div class="pulse-hero-num">
          <span class="z-big-percent">{{ generalDetalle.nps }}%</span>
          <span class="pulse-hero-tag">
            <span class="z-dot pulse-dot" aria-hidden="true"></span>Neto de recomendación
          </span>
          <span class="pulse-hero-period">{{ generalDetalle.period }}</span>
        </div>
      </div>

      <div class="pulse-split">
        <app-nps-breakdown [summary]="generalDetalle" [withBars]="true" />
      </div>

    </div>
  </div>
</section>

<!-- ---------------------------------------------------------------------- -->
<!--                              TENDENCIA                                 -->
<!-- ---------------------------------------------------------------------- -->
<section class="z-panel z-rise z-rise-6">
  <header class="z-panel-head">
    <div>
      <h2 class="z-panel-title">Tendencia</h2>
      <p class="z-panel-hint">
        YTD acumula lo que va del año; Rolling usa la ventana móvil de doce meses.
      </p>
    </div>

    <div class="z-panel-actions">
      <div class="z-toggle" role="group" aria-label="Periodo de la tendencia mensual">
        <button type="button"
                [class.active]="modoTendencia === 'ytd'"
                [attr.aria-pressed]="modoTendencia === 'ytd'"
                (click)="setModoTendencia('ytd')">YTD</button>
        <button type="button"
                [class.active]="modoTendencia === 'rolling'"
                [attr.aria-pressed]="modoTendencia === 'rolling'"
                (click)="setModoTendencia('rolling')">Rolling</button>
      </div>
    </div>
  </header>

  <div class="z-panel-body">
    <h3 class="pulse-subhead">NPS mensual</h3>
    <app-chart [options]="graficaTendencia" [height]="320" />

    <h3 class="pulse-subhead pulse-subhead--gap">Histórico de trece meses</h3>
    <app-chart [options]="graficaHistorico" [height]="320" />
  </div>
</section>

<!-- ---------------------------------------------------------------------- -->
<!--                        POR TIPO DE CLIENTE                             -->
<!-- ---------------------------------------------------------------------- -->
<section class="z-panel z-rise z-rise-7">
  <header class="z-panel-head">
    <div>
      <h2 class="z-panel-title">Por tipo de cliente</h2>
      <p class="z-panel-hint">
        Comerciante y consumidor final, cada uno con su desglose y su histórico.
      </p>
    </div>
  </header>

  <div class="z-panel-body">
    <div class="z-grid z-grid-2">

      <article class="pulse-block">
        <header class="pulse-block-head">
          <h3 class="pulse-block-title">Comerciante</h3>
          <span class="z-big-percent pulse-block-num">{{ comerciante.nps }}%</span>
        </header>

        <app-nps-breakdown [summary]="comerciante" />
        <app-chart [options]="graficaComerciante" [height]="280" />
      </article>

      <article class="pulse-block">
        <header class="pulse-block-head">
          <h3 class="pulse-block-title">Consumidor final</h3>
          <span class="z-big-percent pulse-block-num">{{ consumidor.nps }}%</span>
        </header>

        <app-nps-breakdown [summary]="consumidor" />
        <app-chart [options]="graficaConsumidor" [height]="280" />
      </article>

    </div>
  </div>
</section>

<!-- ---------------------------------------------------------------------- -->
<!--                       SUCURSALES DESTACADAS                            -->
<!-- ---------------------------------------------------------------------- -->
<section class="z-panel z-rise z-rise-8">
  <header class="z-panel-head">
    <div>
      <h2 class="z-panel-title">Sucursales destacadas</h2>
      <p class="z-panel-hint">
        Los dos extremos del ranking de {{ totalSucursales }} sucursales del periodo.
      </p>
    </div>

    <div class="z-panel-actions">
      <a class="z-btn z-btn--glass" routerLink="/explorar">
        <i class="bi bi-arrow-right-short" aria-hidden="true"></i> Ver todas
      </a>
    </div>
  </header>

  <div class="z-panel-body">
    @if (!totalSucursales) {
      <div class="z-empty">
        <i class="bi bi-shop" aria-hidden="true"></i>
        <p>Ninguna sucursal cumple los filtros seleccionados.</p>
      </div>
    } @else {
    <div class="z-grid z-grid-2">

      <div>
        <h3 class="pulse-subhead">Top 5</h3>

        <ul class="z-rank pulse-rank">
          @for (fila of topSucursales; track fila.sucursal) {
            <li>
              <span class="z-rank-pos">{{ fila.posicion }}</span>
              <span class="z-rank-name">{{ fila.sucursal }}</span>
              <span class="z-rank-value">
                {{ fila.nps }}%<span class="z-sr-only">, {{ fila.nivel }}</span>
              </span>
              <div class="z-rank-bar" aria-hidden="true">
                <span [style.background-color]="fila.color" [style.width.%]="fila.nps"></span>
              </div>
            </li>
          }
        </ul>
      </div>

      <div>
        <h3 class="pulse-subhead">Bottom 5</h3>

        <ul class="z-rank pulse-rank">
          @for (fila of bottomSucursales; track fila.sucursal) {
            <li>
              <span class="z-rank-pos">{{ fila.posicion }}</span>
              <span class="z-rank-name">{{ fila.sucursal }}</span>
              <span class="z-rank-value">
                {{ fila.nps }}%<span class="z-sr-only">, {{ fila.nivel }}</span>
              </span>
              <div class="z-rank-bar" aria-hidden="true">
                <span [style.background-color]="fila.color" [style.width.%]="fila.nps"></span>
              </div>
            </li>
          }
        </ul>
      </div>

    </div>
    }
  </div>
</section>
